export const calculateNOI = ({
  rentalIncome,
  taxes,
  insurance,
  other
}: {
  rentalIncome: number;
  taxes: number;
  insurance: number;
  other: number;
}): number => {
  return rentalIncome * 12 - (taxes + insurance + other * 12);
};

export const calculateAnnualDebtService = ({
  loanAmount,
  interestRate,
  amortizationTerm,
  amortizationType
}: {
  loanAmount: number;
  interestRate: number;
  amortizationTerm: number;
  amortizationType: 'Interest Only' | 'Fully Amortizing';
}): number => {
  const rate = interestRate / 100 / 12;
  if (amortizationType === 'Fully Amortizing') {
    const monthlyPayment =
      (loanAmount * rate) / (1 - Math.pow(1 + rate, -amortizationTerm));
    return monthlyPayment * 12;
  } else if (amortizationType === 'Interest Only') {
    return loanAmount * (interestRate / 100);
  }
  return 0;
};

export const calculateDSCR = ({
  NOI,
  annualDebtService
}: {
  NOI: number;
  annualDebtService: number;
}): number => {
  if (annualDebtService === 0) return 0;
  return NOI / annualDebtService / 100;
};
